import CustomText from "pages/_components/CustomText/CustomText";
import FormattedAmount from "pages/_components/FormattedAmount";
import Image from "pages/_components/Image";
import { node, number, string } from "prop-types";
import React from "react";
import EcheckState from "./EcheckState";

const DataEcheck = ({
    numeroCheque,
    estadoCheque,
    emisorNombre,
    emisorTipoDocumento,
    emisorCuit,
    montoCheque,
    fechaEmision,
    fechaPago,
    caracterCheque,
    beneficiarioCheque,
    beneficiarioDocumento,
    emisorMoneda,
    CMC7,
    // endosos,
    // handleExpandEndorsement,
}) => {
    const formatDate = (date, concatString) => {
        if (date) {
            const parts = date.split(/[T\-:]/);

            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10);
            const day = parseInt(parts[2], 10);

            const months = [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre",
            ];

            if (concatString) {
                return `${concatString} ${day} de ${months[month - 1]} de ${year}`;
            }
            return `${day} de ${months[month - 1]} de ${year}`;
        }

        return "";
    };

    return (
        <div className="data-echeck box">
            <div className="data-echeck__logo">
                <Image src="images/logoCompany.svg" />
            </div>
            <CustomText
                text={`${emisorNombre} - ${emisorTipoDocumento?.toUpperCase()} ${emisorCuit}`}
                textType="TEXT"
                className="medium data-echeck__emisor"
            />
            <div className="data-echeck__benefitiary">
                <CustomText text={formatDate(fechaEmision, "Buenos Aires, ")} textType="TEXT" className="medium" />
                <CustomText text={formatDate(fechaPago, "El")} textType="TEXT" className="medium" />
                <div className="data-echeck__benefitiary-name">
                    <CustomText text={`Páguese a: `} textType="TEXT" className="medium" />
                    <CustomText
                        // eslint-disable-next-line max-len
                        text={` ${beneficiarioCheque} - ${emisorTipoDocumento?.toUpperCase()} ${beneficiarioDocumento}`}
                        textType="TEXT"
                        className="medium font-bold"
                    />
                </div>
            </div>
            <div className="data-echeck__line-vertical">
                <Image src="images/figma/illustrations/ticket-dashed-line-vertical.svg" />
            </div>
            {estadoCheque}
            <CustomText text={numeroCheque} textType="TEXT" className="data-echeck__number" />
            <FormattedAmount currency={emisorMoneda} quantity={montoCheque} className="large data-echeck__monto" />
            <EcheckState state={caracterCheque} className="data-echeck__character" />
            <hr className="dotted data-echeck__line-horizontal-one" />
            <hr className="dotted data-echeck__line-horizontal-two" />
            <hr className="dotted data-echeck__line-horizontal-three" />
            <CustomText text={CMC7} textType="TEXT" className="echeq-number data-echeck__echeq-number ellipsis" />
            {/* <GridTable.Data columnStart={3} rowStart={5} alignX="flex-end" alignY="flex-start">
                {endosos && (
                    <Button
                        className="link"
                        bsStyle="link"
                        label="echecks.endosos"
                        type="button"
                        block={false}
                        onClick={handleExpandEndorsement}
                    />
                )}
            </GridTable.Data> */}
        </div>
    );
};

DataEcheck.propTypes = {
    numeroCheque: string.isRequired,
    estadoCheque: node.isRequired,
    emisorNombre: string.isRequired,
    emisorTipoDocumento: string.isRequired,
    emisorCuit: string.isRequired,
    montoCheque: number.isRequired,
    fechaEmision: string.isRequired,
    fechaPago: string.isRequired,
    caracterCheque: string.isRequired,
    beneficiarioCheque: string.isRequired,
    beneficiarioDocumento: string.isRequired,
    CMC7: string.isRequired,
    emisorMoneda: string.isRequired,
    // endosos: arrayOf(shape({})).isRequired,
    // handleExpandEndorsement: func.isRequired,
};

export default DataEcheck;
